export const CSS = {
  wrapper: "wrapper",
  wrapperBordered: "wrapper--bordered",
  container: "container",
  containerHover: "container--hover",
  containerBorder: "container--border",
  containerBorderSelected: "container--border-selected",
  containerBorderUnselected: "container--border-unselected",
  contentContainer: "content-container",
  contentContainerSelectable: "content-container--selectable",
  contentContainerHasCenterContent: "content-container--has-center-content",
  nestedContainer: "nested-container",
  nestedContainerOpen: "nested-container--open",
  content: "content",
  customContent: "custom-content",
  actionsStart: "actions-start",
  contentStart: "content-start",
  label: "label",
  description: "description",
  contentEnd: "content-end",
  contentBottom: "content-bottom",
  actionsEnd: "actions-end",
  selectionContainer: "selection-container",
  selectionContainerSingle: "selection-container--single",
  openContainer: "open-container",
  dragContainer: "drag-container",
  close: "close",
};

export const SLOTS = {
  actionsStart: "actions-start",
  contentStart: "content-start",
  content: "content",
  contentBottom: "content-bottom",
  contentEnd: "content-end",
  actionsEnd: "actions-end",
};

// Set to zero to extend until the end of the table section.
export const MAX_COLUMNS = 0;

export const ICONS = {
  selectedMultiple: "check-square-f",
  selectedSingle: "bullet-point-large",
  unselectedMultiple: "square",
  unselectedSingle: "bullet-point-large",
  closedLTR: "chevron-right",
  closedRTL: "chevron-left",
  open: "chevron-down",
  blank: "blank",
  close: "x",
};

export const activeCellTestAttribute = "data-test-active";
